import { appAxios } from "fd-react/Components/Axios";
import React, { useEffect, useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";

const ReCaptcha: React.FC<{
  setToken: (token: string) => void;
  myRef: any;
}> = (props) => {
  const defaultSiteKey = "6LdhmSUkAAAAAGhbEfpJ3Dvhdh-51LoVh6QfvAWK";
  const [siteKey, setSiteKey] = useState<string>();
  const reCaptchaRef = useRef<any>();
  const onChange = (value: string) => {
    props.setToken(value);
  };

  const getSiteKey = async () => {
    try {
      const siteKeyRes = await appAxios("/api/settings/getReCaptchaSiteKey", {
        baseURL: "",
      });
      if (siteKeyRes.data.success && siteKeyRes.data.result) {
        setSiteKey(siteKeyRes.data.result);
      } else {
        setSiteKey(defaultSiteKey);
      }
    } catch (error) {
      console.log(error);
      setSiteKey(defaultSiteKey);
    }
  };

  useEffect(() => {
    getSiteKey();
  }, []);

  return siteKey ? (
    <ReCAPTCHA
      sitekey={siteKey}
      onChange={onChange}
      ref={props.myRef}
      size="invisible"
      badge="bottomleft"
    />
  ) : (
    <></>
  );
};

export default ReCaptcha;
